import React from "react";
import PropTypes from "prop-types";

import { toAbsoluteUrl } from "../../globals/utils/toAbsoluteUrl";

import "./PoonaWallaNoRecordsFound.scss";

const PoonaWallaNoRecordsFound = ({ title = "No Results Found" }) => {
  return (
    <div className="PoonaWallaNoRecordsFound p-5">
      <div className="PoonaWallaNoRecordsFound__logo mx-auto">
        <img
          src={toAbsoluteUrl("/assets/svg/poonawalla__norecordsfound.svg")}
          alt="No Record Found"
        />
      </div>
      <div className="PoonaWallaNoRecordsFound__message mt-3 text-center">
        <span className="PoonaWallaNoRecordsFound__message-title font-weight-bold">
          {title}
        </span>
      </div>
    </div>
  );
};

export default PoonaWallaNoRecordsFound;

PoonaWallaNoRecordsFound.propTypes = {
  title: PropTypes.string,
};
